import { BuilderTypes } from "../../common-interfaces/api-enums";
import { IProduct } from "./interfaces/IProduct";

export interface IEvent {
  index?: number;
  type?: BuilderTypes.event;
  data: IProduct[];
  configurations: {
    title: string;
  };
}
export enum EventLocationType {
  online = "online",
  physical = "physical",
  url = "url",
}
type Location = {
  lat: number;
  lng: number;
} | null;
export interface IEventCustomData {
  term_and_condition: string;
  redirect_to_checkout: boolean;
  start_date: string;
  end_date: string;
  start_time: string;
  end_time: string;
  location_type: EventLocationType;
  location_url: string | null;
  location_detail: null | string;
  location: Location;
  available_seats: number;
  min_seats: number;
  attendees: number;
  remaining_seats: number;
  enable_registration: boolean;
  start_registration_date: string | null;
  end_registration_date: string | null;
  start_registration_time: string | null;
  end_registration_time: string | null;
}
